import React from 'react'
import Img from 'gatsby-image'
import StepWizard from 'react-step-wizard'
import { injectIntl } from 'react-intl'
import { useStaticQuery, graphql } from 'gatsby'

import Step1Introduction from './Step1-Introduction'
import Step2Register from './Step2-Register'
import Step3Prices from './Step3-Prices'
import Step4NextSteps from './Step4-NextSteps'
import ShowSteps from './ShowSteps'
import * as S from './RegisterWizard.styled'

const RegisterWizard = ({ intl }) => {
  const [stateWizard, setStateWizard] = React.useState({
    previousStep: 0,
    activeStep: 1,
  })

  const images = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  const Nav = props => {
    return (
      <div style={{ display: 'none' }}>
        <button id="go-step-1" onClick={() => props.goToStep(1)}>1</button>
        <button id="go-step-2" onClick={() => props.goToStep(2)}>2</button>
        <button id="go-step-3" onClick={() => props.goToStep(3)}>3</button>
        <button id="go-step-4" onClick={() => props.goToStep(4)}>4</button>
      </div>
    )
  }

  const handleRegister = () => {
    document.querySelector('#go-step-2').click()
  }

  return (
    <S.WizardWrapper>
      <S.Main>
        <Img fixed={images.logo.childImageSharp.fixed} alt="WePayOut" />
        <StepWizard
          nav={<Nav />}
          className="content-wizard"
          isLazyMount={true}
          onStepChange={value => setStateWizard(value)}>
          <Step1Introduction />
          <Step2Register />
          <Step3Prices />
          <Step4NextSteps />
        </StepWizard>
        <S.Footer>
          <div><a href={intl.messages.register.visit_site_link} target="_blank" rel="noreferrer">{intl.messages.register.visit_site}</a></div>
          <div>© {new Date().getFullYear()} WePayOut. {intl.messages.register.copyright}</div>
        </S.Footer>
      </S.Main>
      <S.Aside>
        <div className="wrapper">
          <div className="content-aside">
            <ShowSteps stateWizard={stateWizard} />

            {[1].includes(stateWizard.activeStep) && (
              <button 
                id="new-onboarding-aside"
                onClick={() => handleRegister()}
                style={{ marginBottom: 30 }}
                className="button-next-wizard">
                {intl.messages.register.step1.open_account_now}
              </button>
            )}

            {[1].includes(stateWizard.activeStep) && (
              <S.Tip className="highlight-1">
                <div className="title">{intl.messages.register.tips.ondemand.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.ondemand.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
              </S.Tip>
            )}

            {[4].includes(stateWizard.activeStep) && (
              <S.Tip className="highlight-1">
                <div className="title">{intl.messages.register.tips.production.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.production.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
              </S.Tip>
            )}

            {[1,4].includes(stateWizard.activeStep) && (
              <S.Tip className="highlight-1">
                <div className="title">{intl.messages.register.tips.sandbox.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.sandbox.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
              </S.Tip>
            )}                        

            {[1].includes(stateWizard.activeStep) && (
              <S.Tip className="highlight-1">
                <div className="title">{intl.messages.register.tips.split.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.split.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
              </S.Tip>
            )}

            {[1,2,3].includes(stateWizard.activeStep) && (
              <S.Tip>
                <div className="title">{intl.messages.register.tips.forbusiness.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.forbusiness.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
              </S.Tip>
            )}

            {[1].includes(stateWizard.activeStep) && (
              <S.Tip>
                <div className="title">{intl.messages.register.tips.help.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.help.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
              </S.Tip>
            )}

            {[2,3,4].includes(stateWizard.activeStep) && (
              <S.Tip>
                <div className="title">{intl.messages.register.tips.helpcenter.title}</div>
                <div className="content-tip">
                  {Object.values(intl.messages.register.tips.helpcenter.description).map((value, key) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html: value }} />
                  ))}
                </div>
                {/* <a href="http://ajuda.wepayout.com.br" target="_blank" className="link-tip" rel="noreferrer">Acessar Central de Ajuda</a> */}
              </S.Tip>
            )}

          </div>
        </div>
      </S.Aside>
    </S.WizardWrapper>
  )
}

export default injectIntl(RegisterWizard);